import { IDieuChinhRequest } from "../../model/request/hoa-don-dien-tu/IDieuChinhRequest";
import { IHoaDonDienTuPagingRequest } from "../../model/request/hoa-don-dien-tu/IHoaDonDienTuPagingRequest";
import { IPhatHanhDichVuMultipleRequest } from "../../model/request/hoa-don-dien-tu/IPhatHanhDichVuMultipleRequest";
import { IPhatHanhRequest } from "../../model/request/hoa-don-dien-tu/IPhatHanhRequest";
import { IProcessRequest } from "../../model/request/IProcessRequest";
import { apiClient } from "../apiClient";

export const HOA_DON_DIEN_TU_ENDPOINT = "hoa-don";

export const hoaDonDienTuApi = {
  SelectPaging: (request: IHoaDonDienTuPagingRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/select-hoadondientu-paging`,
      request
    ),
  PhatHanh: (request: IPhatHanhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/phat-hanh`, request),
  PhatHanhMultiple: (request: IProcessRequest<IPhatHanhRequest[]>) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/phat-hanh-multiple?process_id=${request.process_id}`,
      request.payload
    ),
  DieuChinh: (request: IDieuChinhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/dieu-chinh`, request),
  Huy: (id_bien_lai: number) =>
    apiClient.get(`${HOA_DON_DIEN_TU_ENDPOINT}/huy/${id_bien_lai}`),
  Preview: (payload: IPhatHanhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/preview`, payload),
  XemChiTiet: (request: IPhatHanhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/xem-chi-tiet`, request),
  ExportPDF: (id_bien_lai: number) =>
    apiClient.get(`${HOA_DON_DIEN_TU_ENDPOINT}/export-pdf/${id_bien_lai}`),
  PhatHanhNhap: (request: IPhatHanhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/phat-hanh-nhap`, request),
  DongBoTrangThai: (request: IProcessRequest<IHoaDonDienTuPagingRequest>) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/dong-bo-trang-thai?process_id=${request.process_id}`,
      request.payload
    ),
  PhatHanhDichVuMultiple: (request: IPhatHanhDichVuMultipleRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/phat-hanh-dich-vu-multiple`,
      request
    ),
  DongBoDichVuMultiple: (request: IPhatHanhDichVuMultipleRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/dong-bo-dich-vu-multiple`,
      request
    ),
};
